import { createTheme } from '@mui/material';
import { muiComponentOverrideStyles } from 'theme/styles';

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });

const useTheme = () => {
  const theme = createTheme({
    typography: {
      fontFamily: [
        '"Sarabun"',
        'Arial',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        'sans-serif',
      ].join(','),
    },
    palette: {
      primary: {
        main: '#03295F',
        light: '#03295F',
        dark: '#FFFFFF',
      },
      green: createColor('#2CB669'),
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        shell: 800,
        laptop: 1024,
        laptopL: 1281,
        desktop: 1440,
      },
    },
    components: { ...muiComponentOverrideStyles },
  });

  return theme;
};

export default useTheme;
